import React, { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const RibbonWaveSlim = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "linear-gradient(90deg, #F6D5F7 0%, #fff 100%)",
        zIndex: -1, // gradient stays behind
      }}
    >
      <Particles
        id="ribbonWaveSlim"
        init={particlesInit}
        options={{
          fullScreen: { enable: false },
          fpsLimit: 60,
          particles: {
            number: { value: 100, density: { enable: true, area: 800 } },
            size: { value: { min: 2, max: 5 } },
            move: {
              enable: true,
              speed: 0.6,
              direction: "none",
              random: true,
              straight: false,
              outModes: "out",
            },
            opacity: { value: 0.25 },
            color: { value: ["#6211a3ff", "#b700ffff", "#e6f2f1ff"] },
            links: {
              enable: true,
              distance: 180,
              color: "#6125b5ff",
              opacity: 0.2,
              width: 1.5,
            },
          },
          interactivity: {
            events: {
              onHover: { enable: true, mode: "grab" },
            },
            modes: {
              grab: { distance: 200, links: { opacity: 0.4 } },
            },
          },
          detectRetina: true,
        }}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
        }}
      />
    </div>
  );
};

export default RibbonWaveSlim;
